import { render, staticRenderFns } from "./WxTimerDurationInput.vue?vue&type=template&id=dae00c52&scoped=true"
import script from "./WxTimerDurationInput.vue?vue&type=script&lang=js"
export * from "./WxTimerDurationInput.vue?vue&type=script&lang=js"
import style0 from "./WxTimerDurationInput.vue?vue&type=style&index=0&id=dae00c52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae00c52",
  null
  
)

export default component.exports